<template>
  <div class="step_box" style="min-height: 400px">
    <el-steps :active="value" simple>
      <el-step :title="op.Title" :key="op.Id" :icon="op.Icon" v-for="op in options"></el-step>
    </el-steps>
    <template v-for="(s, index) of options">
      <div v-show="index === value" :key="index" class="step_frame">
        <slot :name="'slot' + index"></slot>
      </div>
    </template>
    <slot></slot>
    <div class="p2 flex-row start middle bottom_button s4" v-if="currentStep">
      <div>
        <el-button v-if="currentStep.Last" @click="OnLast">{{ currentStep.LastTitle || '上一步' }}</el-button>
      </div>
      <div style="flex: 1" class="left m02">
        <div class="line1">{{ currentStep.Description }}</div>
      </div>
      <div class="flex-row start middel">
        <el-button type="primary" v-if="currentStep.Next" @click="OnNext">{{ currentStep.NextTitle || '下一步' }}</el-button>
        <el-button type="primary" v-if="currentStep.Finish" @click="OnFinish">{{ currentStep.FinishTitle || '完成' }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    config: Object,
    value: Number,
    role: String,
    roleField: String,
    options: Array
  },
  computed: {
    currentStep() {
      return this.options[this.value || 0]
    }
  },
  methods: {
    OnLast() {
      let res = this.currentStep.Last()
      if (res && res.then) {
        res.then((r) => {
          if (r !== false && this.value > 0) {
            this.$emit('input', this.value - 1)
          }
        })
      } else if (res !== false && this.value > 0) {
        this.$emit('input', this.value - 1)
      }
    },
    OnFinish() {
      let res = this.currentStep.Finish()
      if (res && res.then) {
        res.then()
      } else if (res !== false) {
      }
    },
    OnNext() {
      let res = this.currentStep.Next()
      if (res && res.then) {
        res.then((r) => {
          if (r !== false && this.value < this.options.length - 1) {
            this.$emit('input', this.value + 1)
          }
        })
      } else if (res !== false && this.value < this.options.length - 1) {
        this.$emit('input', this.value + 1)
      }
    }
  }
}
</script>
<style scoped>
.step_box {
  position: relative;
}
.step_frame {
  height: calc(100% - 126px);
  overflow-y: auto;
  overflow-x: hidden;
}
.bottom_button {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
